import { render, staticRenderFns } from "./Cria_Empresas.vue?vue&type=template&id=993c1d0a&scoped=true&"
import script from "./Cria_Empresas.vue?vue&type=script&lang=js&"
export * from "./Cria_Empresas.vue?vue&type=script&lang=js&"
import style0 from "./Cria_Empresas.vue?vue&type=style&index=0&id=993c1d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993c1d0a",
  null
  
)

export default component.exports